import { SecurityTransaction } from '@models/security-transactions/security-transaction';

export class SecurityTransactionIncremental extends SecurityTransaction {
  constructor(data: Partial<SecurityTransactionIncremental> = {}) {
    super(data);
  }
}
